import React, { Component } from 'react'
import { Button, Form, Input, Radio} from 'antd'

import './style.less'
class recharge extends Component {
    render () {
        const { getFieldDecorator } = this.props.form
        return (
            <div className='recharge-page'>
                <Form className="modal-form">

                    <Form.Item label="充值金额" labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
                        {getFieldDecorator('code', {
                            rules: [{ required: true, message: '请输入提现金额' }],
                        })(
                            <Input
                                placeholder="请输入提现金额"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item label="支付方式" labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
                        {getFieldDecorator('radio-group')(
                            <Radio.Group>
                                <Radio value="a">支付宝</Radio>
                                <Radio value="b">微信</Radio>
                            </Radio.Group>,
                        )}
                    </Form.Item>
                </Form>
                <Button className='rechargebtn'>充值</Button>
            </div>
        )
    }
}
export default Form.create({ name: 'post_data' })(recharge)